<div class="mdc-dialog background" id="window-pop-up">
    <div class="mdc-dialog__container poup-container">
        <div class="mdc-dialog__surface close-button-surface" role="alertdialog" aria-modal="true"
            aria-labelledby="my-dialog-title" aria-describedby="my-dialog-content">
            <div>
                <button class=" close-button" (click)="close()">
                    <img id="close-button" [src]="constants.CLOSE_BUTTON" alt="close-button" />
                </button>
            </div>
            <div class="mdc-dialog__surface campaign-dialog" role="alertdialog" aria-modal="true"
                aria-labelledby="my-dialog-title" aria-describedby="my-dialog-content">
                <div class="title_container" id="my-dialog-title">
                    <h4 class="title">{{constants.SIGN_UP_FEATURE_1_TXT}}<br>{{constants.SIGN_UP_FEATURE_2_TXT}}</h4>
                </div>
                <div class="mdc-dialog__content description" id="my-dialog-content">
                    <div class="pop-img-container">
                        <img src="{{constants.BOOKMARK_POPUP_IMG}}" />
                    </div>
                    <p>{{constants.SIGN_UP_FEATURE_DESCRIPTION_1_TXT}}<br>
                        {{constants.SIGN_UP_FEATURE_DESCRIPTION_2_TXT}}<br>
                        {{constants.SIGN_UP_FEATURE_DESCRIPTION_3_TXT}}<br>
                        {{constants.SIGN_UP_FEATURE_DESCRIPTION_4_TXT}}</p>
                    <a [routerLink]="['/signup']" routerLinkActive="router-link-active">
                        <button class="popupButton-before">{{constants.SIGNUP_FOR_FREE_TXT}}
                        </button></a>
                </div>
            </div>
        </div>
    </div>
</div>